import React from 'react';
import { useSelector } from 'react-redux';

const KMLAnalysisComponent = () => {
  const isToolHeight = useSelector((state) => state.currentStage.isToolHeight);
  return (
    <div className="kml-analysis-container"
      style={{ height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }}>
      <iframe
        src="/PMS_KMLAnalysis.htm" // Reference the HTML file in the public folder
        title="KML Analysis"
        width="98%"
        height="100%"
        style={{ display: 'block', border: 'none' }}
      />
    </div>
  );
};

export default KMLAnalysisComponent;
